
import react from 'react';
import { CircleArrowDown } from 'lucide-react';


function App()
{
    
    return(
    <button> <CircleArrowDown /></button>);
}

export default App;